import API from '@/api/index';

const map = {
  actions: {
    GoogleMapDirections ({ commit }, params) {
      return new Promise((resolve, reject) => {
        API.map
          .GoogleMapDirections(params)
          .then(response => {
            if (response.data.Data) { resolve(response.data.Data) }
            else { reject(response.data.Code) }
          })
          .catch(error => { reject(error) });
      });
    },

    GoogleMapGeoCodeding ({ commit }, address) {
      return new Promise((resolve, reject) => {
        API.map
          .GoogleMapGeoCodeding(address)
          .then(response => {
            if (response.data.Data) { resolve(response.data.Data) }
            else { reject(response.data.Code) }
          })
          .catch(error => { reject(error) });
      });
    },

    FastMapDirections ({ commit }, params) {
      return new Promise((resolve, reject) => {
        API.map
          .FastMapDirections(params)
          .then(response => {
            if (response.data.Data) { resolve(response.data.Data) }
            else { reject(response.data.Code) }
          })
          .catch(error => { reject(error) });
      });
    },

    FastMapGeoCodeding ({ commit }, address) {
      return new Promise((resolve, reject) => {
        API.map
          .FastMapGeoCodeding(address)
          .then(response => {
            if (response.data.Data) { resolve(response.data.Data) }
            else { reject(response.data.Code) }
          })
          .catch(error => { reject(error) });
      });
    },
  }
};

export default map;



// WEBPACK FOOTER //
// ./src/store/modules/map.js